<template lang='pug'>
  //- header(class="c-header__wrapper")
  div()
    header(class='o-wrapper c-header' , :class="{'is-fixed' : isActive}")
      button.c-header__menu(class='u-hide@tablet u-fixed' @click='isShowMenu = true')
        i.u-icon menu
      router-link.c-header__logo(:to="{ name: 'Home'}" exact)
        img(:src='company.logoUrl', :alt='company.name')
        h2.c-header__freq.u-mb0.u-mt0.u-ml2(class='u-show@mobile') 99.3FM

      nav(class='u-flex  u-items-center u-show@tablet')
        ul(class='u-flex u-items-center')
          li.c-header__item
            router-link(:to="{ name: 'About'}") la radio
          li.c-header__item
            router-link(:to="{ name: 'Programs'}") programas
          li.c-header__item
            router-link(:to="{ name: 'Contact'}") contáctanos

        ul(class='u-pl4 u-flex u-mt0 u-mb0')
          li()
            button.c-header__text(class='u-px1', @click='showSearch')
              i.u-icon.u-block search
          li(class='u-border-left u-pr2 u-pl3 u-show@laptop' v-if='company.facebookPage')
            a(:href="company.facebookPage", target='_blank')
              i.u-icon.u-block facebook
          li(class='u-px2 u-show@laptop' v-if='company.twitterPage')
            a(:href="company.twitterPage", target='_blank')
              i.u-icon.u-block twitter
          li(class='u-px2 u-show@laptop' v-if='company.youtubePage')
            a(:href='company.youtubePage', target='_blank')
              i.u-icon.u-block youtube
          li(class='u-px2 u-show@laptop' v-if='company.instagramPage')
            a(:href='company.instagramPage', target='_blank')
              i.u-icon.u-block instagram
          li(class='u-pl2 u-show@laptop')
            a(href='https://plus.google.com/111283687522745754180', target='_blank')
              i.u-icon.u-block gplus

        p(class='u-right-align u-mt0 u-mb0 u-show@laptop u-pl4')
          span Escúchanos
          b(class='u-block u-uppercase') Radio en vivo

    //- div()
    //- div()
    //-   nav(class='o-wrapper')


    .c-search(:class="{'is-show' : showSearchFlag}")
      figure.c-search__image
        img(:src='company.logoUrl', :alt='company.name')
      input.u-flex-1.c-search__input(type='text', @keyup='debounceInput($event)', @keyup.enter='searchNews($event)', placeholder='Buscar noticias')
      button.c-search__btn(@click='showSearchFlag = false')
        i.u-icon.u-block close

    app-off-header(v-if='isShowMenu', @hide='isShowMenu = false')
</template>

<script>
  import AppOffHeader from './AppOffHeader'
  import debounce from 'lodash.debounce'
  import { mapGetters } from 'vuex'

  export default {
    components: { AppOffHeader },
    data () {
      return {
        isActive: false,
        isShowMenu: false,
        showSearchFlag: false
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      showSearch () {
        this.showSearchFlag = true
        window.$('.c-search__input').focus()
      },

      searchNews (value) {
        this.showSearchFlag = false
        if (value.target.value.trim()) {
          this.$router.push({name: 'Search', query: { q: value.target.value }})
        } else {
          this.$router.push({name: 'Search'})
        }
      },

      debounceInput: debounce(function (value) {
        if (value.target.value.trim()) {
          this.searchNews(value)
        }
      }, 1000)
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppHeader.vue